import axios from 'axios'
import qs from 'qs'
import router from './router'
import { config } from './config'

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token");
    if (token == undefined) token = "";
    config.headers.Authorization = "Bearer " + token;
    return config;
}, function (error) {
    return console.log(error);
});

axios.interceptors.response.use(res => {
    return res;
}, (err) => {
    if (err.response.status == 401) {
        localStorage.removeItem("token");
        router.push("/login");
    } else {
        console.log(err.response.status);
    }
});

export const uri = config.server;

export const get = (api, params, callback) => axios.get(uri + api, {
    params: params
}).then(res => {
    callback(res.data);
});

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
    .then(res => {
        callback(res.data);
    });

export const postFile = (api, file, callback) => axios.post(uri + api, file, { 'Content-type': 'multipart/form-data' })
    .then(res => {
        callback(res.data);
    });

// 账户
export const loginReq = (params, callback) => get('/BuyerAccount/Login', params, callback);

// 首页
export const getBatchReq       = (params, callback) => get('/BuyerIndex/GetBatch',       params, callback);
export const getNextAccountReq = (params, callback) => get('/BuyerIndex/GetNextAccount', params, callback);
export const getSmsReq         = (params, callback) => get('/BuyerIndex/GetSms',         params, callback);
export const setOkReq            = (params, callback) => get('/BuyerIndex/SetOk',            params, callback);
export const setErrorReq         = (params, callback) => get('/BuyerIndex/SetError',         params, callback);
export const downloadBatchReq    = (params, callback) => get('/BuyerIndex/DownloadBatch',    params, callback);
